import {
  EagleMigrationStateRedirect,
  EagleRegisterLink,
  EagleAndroidAppLink,
  EagleIOSAppLink,
  Channel,
  Topic
} from "../constants/index.js";
import { MessageBrokerUtils } from "./messageBrokerUtils.js";
import { PageContextUtils } from "./pageContextUtils.js";
import { NavigationUtils } from "./navigationUtils.js";

export class MigrationUtils {
  static handleOpenRegistration = (isNative, isIOS) => {
    if (isNative) {
      MigrationUtils.openNativeRegistrationLink(isIOS);
    } else {
      MigrationUtils.openWebRegistrationLink();
    }
    return;
  };

  static register = () => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.registerCompletion,
      headers: {
        publisher: "Registration"
      }
    });
  };

  static openNativeRegistrationLink = isIOS => {
    const link = isIOS ? EagleIOSAppLink : EagleAndroidAppLink;
    NavigationUtils.openExternalUrl(link);
  };

  static openWebRegistrationLink = () => {
    window.location.href = EagleRegisterLink;
    return;
  };

  static isSportRoMigrationOngoing = () => {
    var { configuration } = PageContextUtils.getMigrationData();

    if (configuration.stateId >= EagleMigrationStateRedirect) return true;
    return false;
  };
}
